export default "__VITE_ASSET__ffd76f0d__"